import React from 'react';
import { motion } from 'framer-motion';
import { housingAssociations } from '../data/housingAssociations';
import { RankingCard } from '../components/RankingCard';
export function HousingRankingsPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-43">
      {/* Header */}
      <header className="bg-white border-b border-gray-200" data-id="element-44">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between" data-id="element-45">
          <div className="flex items-center gap-3" data-id="element-46">
            <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center" data-id="element-47">
              <svg viewBox="0 0 24 24" className="w-7 h-7 text-white" fill="currentColor" data-id="element-48">
                <path d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5zm0 18c-3.31 0-6-2.69-6-6V8.5l6-3 6 3V14c0 3.31-2.69 6-6 6z" data-id="element-49" />
                <path d="M7 12l3 3 6-6-1.41-1.41L10 12.17l-1.59-1.58L7 12z" data-id="element-50" />
              </svg>
            </div>
            <span className="text-xl font-bold text-gray-900" data-id="element-51">Multiple</span>
          </div>
          <a href="#contact" className="text-sm text-gray-900 hover:text-blue-600 transition-colors border-b-2 border-gray-900 hover:border-blue-600 pb-0.5" data-id="element-52">
            Contact
          </a>
        </div>
      </header>

      {/* Hero Section */}
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-12" data-id="element-53">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-54">
          <div className="inline-block bg-blue-50 text-blue-600 px-4 py-1.5 rounded-full text-sm font-medium mb-6" data-id="element-55">
            Q4 2025
          </div>
          <h1 className="text-6xl font-bold text-gray-900 mb-4" data-id="element-56">
            Scottish Housing
            <br data-id="element-57" />
            <span className="text-blue-600" data-id="element-58">Performance Rankings</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl leading-relaxed" data-id="element-59">
            Ranking Scotland's housing associations based on a comprehensive
            assessment of resident experience and financial performance. Scores
            combine tenant satisfaction, service quality, financial viability,
            and operational efficiency to identify the highest-performing
            organizations.
          </p>
        </motion.div>
      </div>

      {/* Rankings List */}
      <div className="max-w-7xl mx-auto px-6 pb-20" data-id="element-60">
        <div className="space-y-6" data-id="element-61">
          {housingAssociations.map((association, index) => <RankingCard key={association.id} association={association} rank={index + 1} index={index} data-id="element-62" />)}
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-8" data-id="element-63">
        <div className="max-w-7xl mx-auto px-6 text-center text-sm text-gray-500" data-id="element-64">
          <p data-id="element-65">
            Rankings based on aggregated data from the Scottish Housing
            Regulator, tenant satisfaction surveys, and financial performance
            indicators.
          </p>
          <p className="mt-2" data-id="element-66">
            © 2025 Multiple. Dedicated to improving housing outcomes across
            Scotland.
          </p>
        </div>
      </footer>
    </div>;
}